module.exports = __webpack_public_path__ + "static/img/banner_4.70a111d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_4.png
// module id = dF2A
// module chunks = 1